// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { Icon } from "metabase/ui";

export const EditIcon = styled(Icon)`
  color: var(--mb-color-core-brand);
`;

export const ErrorIcon = styled(Icon)`
  color: var(--mb-color-feedback-negative);
`;

export const SuccessIcon = styled(Icon)`
  color: var(--mb-color-core-summarize);
`;
